import React from 'react';
import AccordionWithChildren from '../../../../components/Accordion/AccordionWithChildren';
import Inputs from './Inputs';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { updateFilter } from '../../../../redux/slices/openData/openDataFiltersSlice';
import { selectFilterOptionsWithDisabled } from '../../../../redux/slices/openData/openDataFiltersSelectors';

const titleToStateKey = {
	'Derechos': 'derechos',
	'Tipo de indicadores': 'tiposIndicadores',
	'Dimensiones': 'dimensiones',
	'ODS': 'ods',
	'Grupos prioritarios': 'priorityGroups',
	'Variables': 'variables'
} as const;

type DisplayTitle = keyof typeof titleToStateKey;

const MultipleInputs = () => {
	const dispatch = useAppDispatch();

	const readyOptions = useAppSelector(selectFilterOptionsWithDisabled);
	const { derechos, tiposIndicadores, dimensiones, ods, priorityGroups, variables } = useAppSelector((state) => state.open_data_filters);

	const selectedMap = {
		derechos,
		tiposIndicadores,
		dimensiones,
		ods,
		priorityGroups,
		variables
	};

	const handleChange = (title: DisplayTitle, selected: string[]) => {
		const filterType = titleToStateKey[title];
		dispatch(updateFilter({ filterType, values: selected }));
	};

	if (!readyOptions) return null;

	const availableFilters = Object.entries(titleToStateKey).filter(([_, key]) => {
		const options = readyOptions[key];
		return options && options.length > 0;
	});

	return (
		<div className="overflow-y-scroll lg:overflow-y-visible w-full h-[calc(100%-126px)] lg:h-fit bg-brand-green-1">
			{availableFilters.map(([displayTitle, key], index) => {
				const title = displayTitle as DisplayTitle;
				const options = readyOptions[key];
				const selectedValues = selectedMap[key];

				return (
					<React.Fragment key={title}>
						{index > 0 && <div className="mx-4 h-[1px] bg-indicator-null" />}
						<AccordionWithChildren title={title} isOpen>
							<Inputs
								options={options}
								selectedValues={selectedValues}
								onChange={(selected) => handleChange(title, selected)}
							/>
						</AccordionWithChildren>
					</React.Fragment>
				);
			})}
		</div>
	);
};

export default MultipleInputs;